
import {throwError as observableThrowError, Observable} from 'rxjs';

import {catchError, map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
//import { Http , Headers} from '@angular/http';
import { ApplicationConstants } from './application-constants';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { basename } from 'path';
import * as XLSX from 'xlsx';
import { WorkBook } from 'xlsx/types';
import { MatTable } from '@angular/material';
import { v4 as uuidv4 } from 'uuid';

/*
  Generated class for the HttpHelper provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class Utils {


  constructor(private http: HttpClient, public applicationConstants: ApplicationConstants) {
  }

  private result:any;
  public loading = false;
  acctList = [];
  acct_number;

  public invokeHttp(url:string , param:any, showBusy:boolean=true):any {

    if (showBusy)
      this.applicationConstants.appComp.showBusyCursor();
    if (param.values != undefined) {
      let fieldName = '';
      if (param.cmd == 'add')
        fieldName = 'created_by';
      else
        fieldName = 'changed_by';
      
      if (fieldName != '') {
        for (let i = 0; i < param.values.length; i++) { 
          if (param.cmd == 'updateAdv' && param.values[i]['flag'] != undefined && 
            (param.values[i]['flag'] == 'new' || param.values[i]['flag'] == '' || param.values[i]['flag'] == 'none')) {
            param.values[i]['created_by'] = this.applicationConstants.user_info.user_name;
              
          }
          else if (param.cmd == 'updateAdv' && param.values[i]['flag'] != undefined && 
            (param.values[i]['flag'] == 'update' || param.values[i]['flag'] == 'delete')) {
              param.values[i]['changed_by'] = this.applicationConstants.user_info.user_name;
          }
          else
            param.values[i][fieldName] = this.applicationConstants.user_info.user_name;

        }
      }
    }

    let paramString = JSON.stringify(param);
    const httpOptions = {
     responseType: 'json' as 'json',
     headers: new HttpHeaders({
       'Content-Type':  'application/x-www-form-urlencoded'
     })
   };
    return this.http.post(url, paramString, httpOptions).pipe(
      map(res => res),
      catchError(this.handleError)
    );
  }

  private handleError = (error: any)=> {
   //console.log(this);
   //console.log(error);
   this.applicationConstants.appComp.hideBusyCursor();
   this.loading = false;
   return observableThrowError(error.message || error);
  }

  public uploadFile(url:string, file:File, param:any):any {

    let formData:FormData = new FormData();
    if (file != null)
      formData.append('uploadFile', file);
    formData.append('param', JSON.stringify(param));

    let headers = new HttpHeaders();
    headers.append('enctype', 'multipart/form-data');
    headers.append('Accept', 'application/json');

    let httpOptions = {
      responseType: 'json' as 'json',
      headers: headers
    };

    return this.http.post(url, formData, httpOptions).pipe(
      map(res => res),
      catchError(this.handleError)
    );
  }

  public returnZeros(baseNumber:Number):String {
    let value = "";
    if (Number(baseNumber) < 10)
      value = "00" + baseNumber;
    else if (Number(baseNumber) < 100)
      value = "0" + baseNumber;
    else// if(baseNumber < 100)
      value = "" + baseNumber;
    
    return value;
  }

  public printReport(html_data:String, tableList:any, form:HTMLFormElement, rep_type:String) {
    
    let table_row, table_bodies, indx, innerText;

    for (let count = 0; count < tableList.length; count++) {
      console.log(tableList[count]['table']);

      if (count > 0)
        html_data += '<br/>';

      if (tableList[count]['title'] != undefined) {
        html_data += '<table cellpadding="8" cellspacing="0">';
        html_data += '<tr><td colspan="2"> ' + tableList[count]['title'] + ' </td></tr>';
        html_data += '</table>';
      }
      html_data += '<table border="1" cellspacing="0" cellpadding="6" style="width: 100%; direction:rtl;">';

      // print table header 
      table_row = tableList[count]['table'].tHead.children[0];
      html_data += '<thead><tr style="background-color:#DEDEDE;">';
      for (indx = 0; indx < table_row.childElementCount; indx++) {
        innerText = table_row.children[indx].innerText;
        html_data += '<td align="center">' + innerText + '</td>';
      }
      html_data += '</tr></thead>';

      // print table body
      table_bodies = tableList[count]['table'].tBodies[0];
      for (let index = 0; index < table_bodies.childElementCount; index++) {
        table_row = table_bodies.children[index];

        html_data += '<tr>';
        for (indx = 0; indx < table_row.childElementCount; indx++) {
          innerText = table_row.children[indx].innerText;
          html_data += '<td align="center">' + innerText + '</td>';
        }
        html_data += '</tr>';
      }

      html_data += '</table>';
    }

    console.log(html_data);
    let html_data_field = document.forms[form.id]['html_data'] as HTMLInputElement;
    html_data_field.value = String(html_data);
    if (rep_type == 'PDF')
      form.action = this.applicationConstants.generatePDF + "?report";
    form.submit();
  }

  public exportToExcel(table:any, file_name:string, type:string = "table") {
    // console.log(file_name);
    var ws: XLSX.WorkSheet;
    if (type == 'json')
      ws = XLSX.utils.json_to_sheet(table);
    
    else
      ws = XLSX.utils.table_to_sheet(table);
    
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    if (!wb.Workbook) wb.Workbook = {};
    if (!wb.Workbook.Views) wb.Workbook.Views = [];
    if (!wb.Workbook.Views[0]) wb.Workbook.Views[0] = {};
    wb.Workbook.Views[0].RTL = true;

    /* save to file */
    XLSX.writeFile(wb, file_name + '.xlsx');
  }

  // public exportToExcel(table:any, file_name:string) {
  //   // console.log(file_name);
  //   const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(table);
  //   const wb: XLSX.WorkBook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

  //   if (!wb.Workbook) wb.Workbook = {};
  //   if (!wb.Workbook.Views) wb.Workbook.Views = [];
  //   if (!wb.Workbook.Views[0]) wb.Workbook.Views[0] = {};
  //   wb.Workbook.Views[0].RTL = true;

  //   /* save to file */
  //   XLSX.writeFile(wb, file_name + '.xlsx');
  // }

  public getParamValue(key:string):string {
    if (this.applicationConstants.param[key] != undefined) {
      console.log(this.applicationConstants.param[key]);
      return this.applicationConstants.param[key];
    }  
    else
      return "NPV";
  }

  numberFormat(value) {
    return Number(value).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  }

  public snakeToCamel(str) {
    return str.replace(/(\_\w)/g, function(m){return m[1].toUpperCase();});
  }

  public getAuth(menu_item_id, authType):boolean {
    console.log(this.applicationConstants.user_info['authList']);
    var item = this.applicationConstants.user_info['authList'].find(function(itm) {
        return itm['menu_item_id'] == menu_item_id;
        });
    //console.log(item);
    if (item != undefined) {
      if (item[authType] == 1)
        return true;
      else return false;
    }
    else
      return false;
  }

  public getDPIndex(dataList, property, value):number {
    let index = -1;
    
    for (let count = 0; count < dataList.length; count++) {
      let element = dataList[count];
      if (element[property] == value) {
        index = count;
        break;
      }
    }
    return index;
  }

  public returnSaleInvoice(invoice_detail, return_date, comp) {
    let query, obj;

    if (invoice_detail['item_list'] == undefined) {
      
      //get payment methods
      query = "SELECT * FROM `inv_payment_method` WHERE `status` = '1' AND `invoice_no` = '" + 
        invoice_detail.invoice_no + "'";
      obj = { cmd: 'getList', query: query };

      this.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          invoice_detail['payment_list'] = data.data['list'];

          //get invoice items
          obj = { cmd: 'getInvoiceItem', type: 'invoice', invoice_no: invoice_detail.invoice_no, 
            for_return: true };
          
          this.invokeHttp(this.applicationConstants.saleFuncFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();

            if (data.status['type'] == 'success') {
              invoice_detail['item_list'] = data.status['msg'];

              query = "SELECT `cash_receipt`.`cash_receipt_no`, `cash_receipt`.`paid` FROM " +
                "`cash_receipt`, `cash_receipt_invoice` WHERE `cash_receipt_invoice`.`invoice_no` = '" +
                invoice_detail.invoice_no + "' AND `cash_receipt_invoice`.`status` != '0' AND " +
                "`cash_receipt_invoice`.`cash_receipt_no` = `cash_receipt`.`cash_receipt_no`";

              obj = { cmd: 'getList', query: query };

              this.invokeHttp(this.applicationConstants.generalFile, obj)
                .subscribe(data => {
                  this.applicationConstants.appComp.hideBusyCursor();
                  invoice_detail['has_cash_receipt'] = (data.data['list'].length > 0 ? 1 : 0);

                  this.addReturnInvoice(invoice_detail, return_date, comp);
                });
            }
            else 
              alert(comp.Error_Msg);  
          });
        });
    }
    else {
      query = "SELECT `cash_receipt`.`cash_receipt_no`, `cash_receipt`.`paid` FROM " +
        "`cash_receipt`, `cash_receipt_invoice` WHERE `cash_receipt_invoice`.`invoice_no` = '" +
        invoice_detail.invoice_no + "' AND `cash_receipt_invoice`.`status` != '0' AND " +
        "`cash_receipt_invoice`.`cash_receipt_no` = `cash_receipt`.`cash_receipt_no`";

      obj = { cmd: 'getList', query: query };

      this.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          invoice_detail['has_cash_receipt'] = (data.data['list'].length > 0 ? 1 : 0);

          this.addReturnInvoice(invoice_detail, return_date, comp);
        });
    }
      // this.addReturnInvoice(invoice_detail, comp);
  }

  public addReturnInvoice(invoice_detail, return_inv_date, comp) {
    let values = [];
    let obj, return_date, current_year;

    if (return_inv_date == '') {
      return_date = ((new Date()).getFullYear() + "-" + ((new Date()).getMonth() + 1) + "-" + 
        (new Date()).getDate() + ' ' + (new Date()).getHours() + ':' + (new Date()).getMinutes() +
        ':' + (new Date()).getSeconds());

        current_year = new Date().getFullYear();
    }
    else {
      return_date = (return_inv_date.getFullYear() + "-" + (return_inv_date.getMonth() + 1) + "-" + 
      return_inv_date.getDate() + ' ' + return_inv_date.getHours() + ':' + return_inv_date.getMinutes() +
        ':' + return_inv_date.getSeconds());

      current_year = return_inv_date.getFullYear();
    }

    let is_equal_ret = true;
    invoice_detail['item_list'].forEach(element => {
      if (element.sale_ret_acct_no != invoice_detail['item_list']['0']['sale_ret_acct_no'])
        is_equal_ret = false;
    });
    let ret_sales_acct = '';
    if (is_equal_ret)
      ret_sales_acct = invoice_detail['item_list']['0']['sale_ret_acct_no'];

    let invoice_uuid = uuidv4();
    console.log(invoice_detail.customer_no);
      
    
    //return_invoice
    values.push({
      'table_name': 'return_invoice', 'return_invoice_id': '0', 'return_invoice_no': '0', 'no': '0', 'year': current_year,
      'invoice_no': invoice_detail.invoice_no, 'return_date': return_date, 'total': invoice_detail.total, 
      'discount': invoice_detail.discount, 'tax': invoice_detail.tax, 'tax_acct': invoice_detail.tax_acct, 
      'ret_sales_acct': ret_sales_acct, 'payment_method': invoice_detail.payment_method, 
      'acct_number': invoice_detail.acct_number, 'is_paid': invoice_detail.is_paid, 'flag': 'new', 
      'key': 'return_invoice_id', 'status': '3', 'comment': '', 'cost_center': invoice_detail.cost_center, 
      'branch_id': invoice_detail.branch_id, 'store_id': invoice_detail.store_id, 'invoice_uuid': invoice_uuid , 
      'customer_no': invoice_detail.customer_no
    });

    //return_invoice_item
    invoice_detail['item_list'].forEach(element => {
      values.push({
        'table_name': 'return_invoice_item', 'return_invoice_no': '', 'invoice_item_id': element.invoice_item_id,
        'sub_item_number': element.sub_item_number, 'sub_item_name': element.sub_item_name,
        'return_count': element.count, 'price': element.price, 'unit_id': element.unit_id,
        'return_tax': element.tax_amount, 'total_price': element.total_price,
        'discount': element.discount, 'tax_no': element.tax_no, 'damage': '0',
        'damage_reason': '', 'stock_no': element.stock_no, 'return_date': return_date,
        'store_id': element.store_id, 'primary_sub_item_number': element.primary_sub_item_number,
        'flag': 'new', 'key': 'return_item_id', 'return_item_id': '0',
        'primary_quantity': (element.stock_no != '0' ? (Number(element.count) * Number(element.primary_quantity)).toFixed(2) : '0'),
        'comment': '', 'sale_ret_acct_no': element.sale_ret_acct_no
      });
    });

    //return_invoice_payment_method
    invoice_detail['payment_list'].forEach(element => {
      values.push({
        'table_name': 'ret_inv_payment_method', 'return_invoice_no': '',
        'ret_inv_payment_method_id': '0', 'flag': 'new', 
        'key': 'ret_inv_payment_method_id', 'payment_type_id': element.payment_type_id, 
        'acct_number': element.acct_number, 'amount': element.amount
      });
    });

    let idWhere = " WHERE `year` = '" + current_year + "' AND `branch_id` = '" + 
      invoice_detail.branch_id + "'";
    let prefix = 'RET-' + invoice_detail.branch_id + "-" + current_year;

    obj = {
      cmd: 'add', values: values, pk: 'return_invoice_no', id: 'no', main_table: 'return_invoice',
      prefix: prefix, idWhere: idWhere
    };
    // obj = { cmd: 'add', values: values, pk: 'return_invoice_no', id: 'return_invoice_id', 
    //   main_table: 'return_invoice', prefix: prefix };

    this.invokeHttp(this.applicationConstants.generalFile, obj)
    .subscribe(data => {
      this.applicationConstants.appComp.hideBusyCursor();

      if (data.status['type'] == 'success') {
        let ret_invoice_no = data.status['msg'][0]['number'];

        values = [];
        let where = [];

        // change invoice status to 3
        values.push({ 'table_name': 'invoice', 'status': '3' });
        where.push({'invoice_no': invoice_detail.invoice_no});

        // change invoice acct log status to 3
        values.push({ 'table_name': 'acct_log', 'status': '3' });
        where.push({'source': 'invoice', 'log': invoice_detail.invoice_no, 'status': '1' });

        if (invoice_detail.invoice_type == 'pos') {
          // delete qutation
          values.push({ 'table_name': 'qutation', 'status': '3' });
          where.push({'qutation_no': invoice_detail.qutation_no});

          // empty reserved table 
          values.push({ 'table_name': 'serv_table', 'qutation_no': '', 'res_status': '1' });
          where.push({'qutation_no': invoice_detail.qutation_no});
        }
        else if (invoice_detail.invoice_type == 'program' || invoice_detail.invoice_type == 'special_prog') {

          // delete trip group 
          values.push({ 'table_name': 'trip_group', 'status': '0' });
          where.push({'invoice_no': invoice_detail.invoice_no});

          // delete reg on hotel 
          values.push({ 'table_name': 'reg_on_hotel', 'status': '0' });
          where.push({'invoice_no': invoice_detail.invoice_no});

          // delete reg on visa 
          values.push({ 'table_name': 'reg_on_visa', 'status': '0' });
          where.push({'invoice_no': invoice_detail.invoice_no});

          // delete reg on bus 
          values.push({ 'table_name': 'reg_on_bus', 'status': '0' });
          where.push({'invoice_no': invoice_detail.invoice_no});

          // delete reg on ticket 
          values.push({ 'table_name': 'reg_on_ticket', 'status': '0' });
          where.push({'invoice_no': invoice_detail.invoice_no});
        }
        else if (invoice_detail.invoice_type == 'flight' || invoice_detail.invoice_type == 'flight_block') {

          // delete trip group 
          values.push({ 'table_name': 'trip_group', 'status': '0' });
          where.push({'invoice_no': invoice_detail.invoice_no});

          // delete reg on ticket 
          values.push({ 'table_name': 'reg_on_ticket', 'status': '0' });
          where.push({'invoice_no': invoice_detail.invoice_no});

          if (invoice_detail.invoice_type == 'flight_block') {

            // delete flight block 
            values.push({ 'table_name': 'flight_block', 'status': '0' });
            where.push({'invoice_no': invoice_detail.invoice_no});
          }
        }

        obj = { cmd: 'update', values: values, where: where };

        this.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();
            
            if (data.status['type'] == 'success') {

              if (comp.menu_item_id == '9999' || invoice_detail['has_cash_receipt'] == 1) {
                obj = { cmd: 'updateCashReceipt', user_name: this.applicationConstants.user_info['user_name'] };

                if (comp.menu_item_id == '9999') {
                  obj['old_invoice_no'] = invoice_detail.invoice_no;
                  obj['new_invoice_no'] = comp.invoice_model['invoice_no'];
                }
                else if (invoice_detail['has_cash_receipt'] == 1) 
                  obj['returned_invoice_no'] = invoice_detail.invoice_no;

                this.invokeHttp(this.applicationConstants.saleFuncFile, obj)
                .subscribe(data => {
                  this.applicationConstants.appComp.hideBusyCursor();

                  if (data.status['type'] == 'error')
                    alert(this.applicationConstants.user_lang == 'ar' ? data.status['msg'][0]['msg_ar'] : data.status['msg'][0]['msg_en']);
                  else {
                    if (comp.menu_item_id == '9999') {
                      alert(comp.Cancel_Invoice_Msg + comp.Ret_No_Msg + ret_invoice_no + "\n" + 
                        comp.Change_Prog_Msg2 + comp.invoice_model['invoice_no']); 
                    }
                    else {
                      alert(comp.Cancel_Invoice_Msg + comp.Ret_No_Msg + ret_invoice_no);

                      if (comp.list_type != undefined)
                        comp.search(comp.list_type);
                      else
                        comp.search(); 
                    }
                  }
                
                });
              }
              else {
                if (comp.menu_item_id == '9999') {
                  alert(comp.Cancel_Invoice_Msg + comp.Ret_No_Msg + ret_invoice_no + "\n" + 
                    comp.Change_Prog_Msg2 + comp.invoice_model['invoice_no']); 
                }
                else {
                  alert(comp.Cancel_Invoice_Msg + comp.Ret_No_Msg + ret_invoice_no);

                  if (comp.list_type != undefined)
                    comp.search(comp.list_type);
                  else
                    comp.search(); 
                }
              }
            }
            else {
              alert(comp.Error_Msg);
            }
          });
      }
      else
        alert(comp.Error_Msg);
    });
  }

// public getCustList(branch_id: string) {
//   let obj;

//   if (this.applicationConstants.param['is_account'] == '1') {
//     // get leaf customer accts
//     let branch_list = [{ 'branch_id': branch_id }];
//     let parent_acct = this.applicationConstants.main_acct_config['customer'];
//     obj = { cmd: 'getAccountList', parent_acct: parent_acct, add_leaf: true, only_leaf: true, 
//       check_cc: false, type: 'customer', branch_list: branch_list };

//     this.invokeHttp(this.applicationConstants.functionFile, obj, false)
//       .subscribe(data => {
//         // this.applicationConstants.appComp.hideBusyCursor();
//         this.applicationConstants.customerList = data.data['list'];

//         data.data['list'].forEach(element => {
//           if (element.is_cc == '1')
//             this.applicationConstants.counterCustList.push(element);
//         });
//       });
//   }
//   else {
//     let query = "SELECT `customer`.*, `sub_acct`.`sub_acct_name`, `sub_acct`.`sub_acct_name_en` " + 
//       "FROM `customer`, `sub_acct` WHERE `customer`.`status` = '1' AND `customer`.`branch_id` = '" + 
//       branch_id + "' AND `customer`.`acct_number` = `sub_acct`.`acct_number`";
//     obj = { cmd: 'getList', query: query };

//     this.invokeHttp(this.applicationConstants.generalFile, obj, false)
//       .subscribe(data => {
//         // this.applicationConstants.appComp.hideBusyCursor();
//         this.applicationConstants.customerList = data.data['list'];

//         this.applicationConstants.customerList.forEach(element => {
//           element.value = element.acct_number + " - " + element.sub_acct_name + " - " + 
//             element.sub_acct_name_en + " - " + element.mobile;

//           if (element.is_account == '1')
//             this.applicationConstants.counterCustList.push(element);
//         });
//       });
//   }
// }


//  public seCheckboxVal(val:boolean)
//  {
//     if(val) return '1';
//     else return '0';
//  }

  /********************* Executed once the user has already logged on to the system to get the master data ***************/
  

//     /**
//      * Returns a reference to the class object of the class specified by the name parameter.
//      * @param name The name of a class.
//      */
//     public getDefinitionByName(name:string):any {
//       let getDefinitionByNameCache = {};  
//       var __global = __global || this;
//       if (!name)
//             return null;
//         let definition = getDefinitionByNameCache[name];
//         if (definition) {
//             return definition;
//         }
//         let paths = name.split(".");
//         let length = paths.length;
//         definition = __global;
//         for (let i = 0; i < length; i++) {
//             let path = paths[i];
//             definition = definition[path];
//             if (!definition) {
//                 return null;
//             }
//         }
//         getDefinitionByNameCache[name] = definition;
//         return definition;
//     }




// /**
//      * Return the fully qualified class name of an object
//      * @param value The object for which a fully qualified class name is desired. Any JavaScript value may be passed to
//      * this method including all available JavaScript types, object instances, primitive types such as number, and class objects.
//      * @returns A string containing the fully qualified class name.
//      */
//     public  getQualifiedClassName(value:any):string {
//       let type = typeof value;
//       if (!value || (type != "object" && !value.prototype)) {
//           return type;
//       }
//       let prototype:any = value.prototype ? value.prototype : Object.getPrototypeOf(value);
//       if (prototype.hasOwnProperty("__class__")) {
//           return prototype["__class__"];
//       }
//       let constructorString:string = prototype.constructor.toString().trim();
//       let index:number = constructorString.indexOf("(");
//       let className:string = constructorString.substring(9, index);
//       Object.defineProperty(prototype, "__class__", {
//           value: className,
//           enumerable: false,
//           writable: true
//       });
//       return className;
//   }

//   /**
//    * Returns the fully qualified class name of the base class of the object specified by the value parameter.
//    * @param value The object for which a parent class is desired. Any JavaScript value may be passed to this method including
//    * all available JavaScript types, object instances, primitive types such as number, and class objects.
//    * @returns  A fully qualified base class name, or null if none exists.
//    */
//   public  getQualifiedSuperclassName(value:any):string {
//       if (!value || (typeof value != "object" && !value.prototype)) {
//           return null;
//       }
//       let prototype:any = value.prototype ? value.prototype : Object.getPrototypeOf(value);
//       let superProto = Object.getPrototypeOf(prototype);
//       if (!superProto) {
//           return null;
//       }
//       let superClass = this.getQualifiedClassName(superProto.constructor);
//       if (!superClass) {
//           return null;
//       }
//       return superClass;
//   }

}
